"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResource = void 0;
var use_request_1 = require("@clover-util/use-request");
var createResourceHook_1 = require("./createResourceHook");
exports.useResource = (0, createResourceHook_1.createResourceHook)(use_request_1.useRequest);
